import {useReducer} from 'react'
import {ICompanyEnum} from '@bdswiss/common-enums'

import {AccountCardProps} from '../types'
import {reducer} from './reducer'
import {ActionType} from './actions'
import {initialState} from './initialState'
import {PammInvestorMinimumDepositRequiredPopup} from './components/Popups/PammInvestorMinimumDepositRequiredPopup'
import {toPammPortal} from './toPammPortal'
import invariant from 'tiny-invariant'
import {Account, PammTauroMarketsAccount} from '../../../../../graphql/types'
import {PammInvestorPendingPopup} from './components/Popups/PammInvestorPendingPopup'
import {PammInvestorTransferNeededPopup} from './components/Popups/PammInvestorTransferNeededPopup'
import {PammInvestorAccountCard} from './components/PammInvestorAccountCard'
import {getPammInvestorCardState} from './getPammInvestorCardState'

type PammTauroMarketsAccountCardProps = AccountCardProps & {
  account: PammTauroMarketsAccount,
  company: ICompanyEnum,
  restAccounts: Account[],
}

export const PammTauroMarketsAccountCard: React.FC<PammTauroMarketsAccountCardProps> = ({account, company, restAccounts}: PammTauroMarketsAccountCardProps) => {
  const [
    {
      showMinimumDepositRequiredPopup,
      showTransferNeededPopup,
      showPendingPopup,
    },
    dispatch
  ] = useReducer(reducer, {...initialState, account})

  const closeModals = () => {
    dispatch({type: ActionType.CloseModal})
  }

  const {
    investorBalance,
    isDepositNeeded,
    isTransferNeeded,
    isUnapproved,
  } = getPammInvestorCardState(account, restAccounts)

  const handleClick = () => {
    if (account != null && (isDepositNeeded || isTransferNeeded || isUnapproved)) {
      dispatch({
        type: ActionType.Click,
        payload: {
          isDepositNeeded,
          isTransferNeeded,
          isUnapproved,
        },
      })
    } else {
      invariant(account.id, 'Account id is required')
      toPammPortal(account.id)
    }
  }

  return (
    <>
      <PammInvestorAccountCard
        account={account}
        company={company}
        isDepositNeeded={isDepositNeeded}
        isUnapproved={isUnapproved}
        restAccounts={restAccounts}
        onClick={handleClick}
      />
      <PammInvestorMinimumDepositRequiredPopup
        account={account}
        company={company}
        investorBalance={investorBalance}
        onClose={closeModals}
        open={showMinimumDepositRequiredPopup}
      />
      {account.id ? (
        <PammInvestorTransferNeededPopup
          accountId={account.id}
          company={company}
          onClose={closeModals}
          open={showTransferNeededPopup}
        />
      ) : null}
      <PammInvestorPendingPopup
        account={account}
        company={company}
        onClose={closeModals}
        open={showPendingPopup}
      />
    </>
  )
}
